import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../constants'
import { Gpname } from '../../../model/gpname'
import { ItemListComponent } from '../item-list/item-list.component'
import { ViewEncapsulation } from '@angular/core';
import { FormGroup, UntypedFormControl, FormsModule, Validators } from '@angular/forms'
import { StringValidator } from '../base-item/string.validator'

declare var require: any

@Component({
  selector: 'app-gpname-list',
  templateUrl: '../item-list/item-list.component.html',
  styleUrls: ['../../../styles/global.scss','../item-list/item-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GpnameListComponent extends ItemListComponent {

  public id: string

// OVERRIDDEN METHODS:

  setParams(params) {
    this.id = params.id
  }

  getLinkToEdit(item) {
    // console.log("Item = ", item)
    return "/data/champ/"+this.id+"/gpnames/"+item.pattern
  }

  getItemsName() {
    return this.id.toUpperCase()+" GP Names"
  }

  getItemName() {
    return this.id.toUpperCase()+" GP Name"
  }

  getItemId(item) {
    return item.pattern
  }

  addItemTHValues(tableid) {
    let str = ""
    let tab = document.getElementById(tableid)
    if (!tab)
      return
    let elem = this.addElement(tab, "thead", '')
    if (!elem)
      return
    while (elem.firstChild) {
      elem.removeChild(elem.lastChild)
    }
    this.addElement(elem, 'th', 'Champ')
    this.addElement(elem, 'th', 'Pattern')
    this.addElement(elem, 'th', 'Name')
    this.addElement(elem, 'th', '')
  }


  addItemTDValues(item) {
    let elem = document.getElementById(this.getTableId())
    if (!elem)
      return
    let tr = this.addElement(elem, "tr", '')
    if (!tr)
      return
    this.addElement(tr, 'td', item.id)
    tr.onclick = (event) => this.editItem(event, item)
    this.addElement(tr, 'td', item.pattern)
    this.addElement(tr, 'td', item.name)
    let btn = this.addDeleteButtonIcon(tr, 'td', this.canEdit())
    btn.onclick = (event) => this.askDeleteItem(event, item)
  }

  getItems() {
    if (this.id === undefined)
      return
    document.body.style.cursor='wait';
    this.dataService.getGpnames(this.id)
        .subscribe(items => this.afterGetItems(items))
  }


  deleteItem(item) {
    document.body.style.cursor='wait';
    this.dataService.deleteGpname(this.id, item.pattern)
      .subscribe(res => this.afterSuccessfulDelete(res),
                 response => this.afterFailedDelete(response))
  }

  getValidators() {
    let vals = {}
    vals["pattern"] = [Validators.required, StringValidator.cannotContainSpace]
    vals["id"] = [Validators.required, StringValidator.cannotContainSpace]
    return vals
  }

  getDisabledFields() {
    let list = ["id"]
    return list
  }

  getNewItem() {
    return Gpname.getNewItem(this.id)
  }

  createItem(form) {

    let item = new Gpname()
    this.updateValues(item, form)
    let cat = item.toJson()
    this.dataService.updateGpname(this.id, cat)
    .subscribe(
      val => this.dataSuccess(val, 'PUT'),
      err => this.dataError(err, 'PUT'),
      () => {}
    )
  }

  updateValues(cat: Gpname, form: any) {
    let keys = this.getFormKeys(form)
    for (const key of keys) {
      if (form.get(key) instanceof UntypedFormControl) {
         cat[key] = form.get(key).value
      }
    }
  }

  haveDeleteAllFeature() {
    return false
  }

// END: OVERRIDDEN METHODS


}
